import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard, CanAccessRouteGuard } from '@thehubz/client/core';
import { CollectionHistoryComponent } from '../collection-history/collection-history.component';
import { CollectionAssetListViewComponent } from './collection-asset-view.component';
import { CustomClientMetadataComponent } from './custom-client-metadata/custom-client-metadata.component';
import { GeneralInfoComponent } from './general-info/general-info.component';
import { ThumbnailListComponent } from './thumbnail-list/thumbnail-list.component';

const routes: Routes = [
  {
    path: '',
    component: CollectionAssetListViewComponent,
    canActivate: [AuthenticationGuard],
    children: [
      { path: '', redirectTo: 'collection-assets', pathMatch: 'full' },
      {
        path: 'collection-assets',
        data: { label: $localize`:collection tab:Assets` },
        component: ThumbnailListComponent,
      },
      {
        path: 'general-info',
        data: { label: $localize`:collection tab:General info`, collectionOwnerCheck: true },
        component: GeneralInfoComponent,
      },
      {
        path: 'collection-metadata',
        data: { label: $localize`:collection tab:Metadata`, clientsSpecific: true }, // clientsSpecific specify if we have custom clients
        component: CustomClientMetadataComponent,
        canActivate: [CanAccessRouteGuard],
      },
      {
        path: 'collection-history',
        data: { label: $localize`:collection tab:History` },
        component: CollectionHistoryComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CollectionAssetViewRoutingModule {}
